import {
	getPerpMarketPublicKeySync,
	getSpotMarketPublicKeySync,
	PublicKey,
	VELOCITY_PROGRAM_ID,
} from '@velocity-exchange/sdk';
import Env from '../../environmentVariables/EnvironmentVariables';

export const FEE_STRATEGY_TARGET_PERCENTILE =
	Env.dynamicFeeTargetPercentile ?? 0;
export const FEE_SUBSCRIPTION_SLOT_LOOKBACK = 10;

const VELOCITY_PROGRAM_ID_PUBKEY = new PublicKey(VELOCITY_PROGRAM_ID);

export const PRIORITY_FEE_SUBSCRIPTION_ADDRESSES = [
	getPerpMarketPublicKeySync(VELOCITY_PROGRAM_ID_PUBKEY, 0), // SOL-PERP
	getSpotMarketPublicKeySync(VELOCITY_PROGRAM_ID_PUBKEY, 0), // USDT (quote)
];

export const BOOSTED_MULITPLIER = 5;
export const TURBO_MULTIPLIER = 10;
